import { render, staticRenderFns } from "./EstimatesOldSpecsItemSidepage.vue?vue&type=template&id=7433c4b2&"
import script from "./EstimatesOldSpecsItemSidepage.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldSpecsItemSidepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports